import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { name: '首页', path: '/', icon: 'ri-home-4-line' },
  { name: '电影', path: '/category/movie', icon: 'ri-film-line' },
  { name: '电视剧', path: '/category/tv', icon: 'ri-tv-line' },
  { name: '综艺', path: '/category/variety', icon: 'ri-live-line' },
  { name: '动漫', path: '/category/anime', icon: 'ri-rocket-line' },
  { name: '纪录片', path: '/category/documentary', icon: 'ri-global-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.06)]'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 mx-auto" style={{ maxWidth: '1400px' }}>
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-lg text-white"></i>
            </div>
            <span className={`font-heading font-bold text-lg whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              91精品影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  isActive(item.path)
                    ? scrolled
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-white bg-white/15'
                    : scrolled
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                scrolled ? 'text-foreground-500 hover:text-foreground-800' : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <div className={`relative ${scrolled ? 'text-foreground-400' : 'text-white/50'}`}>
              <i className="ri-search-line text-lg"></i>
              <input
                type="text"
                placeholder="搜索影片..."
                className={`pl-8 pr-4 py-2 rounded-full text-sm border outline-none transition-all duration-200 w-48 focus:w-64 ${
                  scrolled
                    ? 'bg-background-100 border-background-200 text-foreground-800 placeholder-foreground-400 focus:border-primary-400'
                    : 'bg-white/10 border-white/20 text-white placeholder-white/50 focus:bg-white/20 focus:border-white/40'
                }`}
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive(item.path)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
                {item.name}
              </Link>
            ))}
            <div className="pt-2 border-t border-background-200">
              <Link
                to="/about"
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}